export default __webpack_public_path__ + "static/media/forward_thin_blue.55407530.svg";